<div class="row mb-3">
    <div class="col-6">
        <div class="d-flex align-items-end">
            <div class="flex-grow-1">
                <label class="form-label">Cantidad minima</label>
                <input type="number" class="form-control" [(ngModel)]="pregunta.MinimoItemsSeleccionados"
                       [disabled]="pregunta.MinimoItemsSeleccionados === 0 || accesoPublico">
            </div>
            <div class="form-check form-switch ms-2 mb-2">
                <input class="form-check-input" type="checkbox" role="switch" id="sin-limite-minimo"
                       (change)="toggleLimiteMinimo()" [ngModel]="pregunta.MinimoItemsSeleccionados === 0"
                       [disabled]="accesoPublico">
                <label class="form-check-label text-nowrap" for="sin-limite-minimo">Sin limite</label>
            </div>
        </div>
    </div>
    <div class="col-6">
        <div class="d-flex align-items-end">
            <div class="flex-grow-1">
                <label class="form-label">Cantidad maxima</label>
                <input type="number" class="form-control" [(ngModel)]="pregunta.MaximoItemsSeleccionados"
                    [disabled]="pregunta.MaximoItemsSeleccionados === 0 || accesoPublico">
            </div>
            <div class="form-check form-switch ms-2 mb-2">
                <input class="form-check-input" type="checkbox" role="switch" id="sin-limite-maximo"
                       (change)="toggleLimiteMaximo()" [ngModel]="pregunta.MaximoItemsSeleccionados === 0"
                       [disabled]="accesoPublico">
                <label class="form-check-label text-nowrap" for="sin-limite-maximo">Sin limite</label>
            </div>
        </div>
    </div>
</div>
<div class="row" *ngFor="let item of items; index as i">
    <div class="col d-flex align-items-center mb-1">
        <h3 class="mb-0 pe-1 mas-chico" [style.color]="colores[obtenerId(pregunta.Tipo)]"
            [attr.item-id]="(!accesoPublico ? item.Id : null)"
            ngbTooltip="{{(!accesoPublico ? item.Id : null)}}" container="body">
            {{ item.IdRelativo }}
        </h3>
        <input type="text" class="form-control white-borders" [(ngModel)]="item.Texto" [disabled]="accesoPublico" />
        <div class="col flex-grow-0 text-end mt-auto seleccionable" (click)="abrirEditorCondicionesItem(item)"
             *ngIf="!accesoPublico">
            <span>
                <i class="fa-regular fa-list-check fa-xl"></i>
            </span>
        </div>
        <div class="col flex-grow-0 text-end my-auto" [class.seleccionable]="borrarItemCmd.puedeEjecutarse"
            (click)="clickBorrarItem(item)" *ngIf="!accesoPublico">
            <span><i class="fa-regular fa-trash-can fa-xl"></i></span>
        </div>
    </div>
</div>
<div class="row" *ngIf="!accesoPublico">
    <div class="col flex-grow-0 h3 mb-0 pe-0">+</div>
    <div class="col mb-3">
        <input type="text" placeholder="Agregue una respuesta..." class="form-control no-borders"
            [(ngModel)]="textoItem" (keyup.enter)="agregarCmd.ejecutar()" [disabled]="!agregarCmd.puedeEjecutarse" />
    </div>
</div>

